import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';
import moment from 'moment';
import 'moment-recur';

import Button from 'material-ui/Button';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle
} from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import { MenuItem } from 'material-ui/Menu';
import Select from 'material-ui/Select';
import { InputLabel } from 'material-ui/Input';
import {
    FormLabel,
    FormControl,
    FormGroup,
    FormControlLabel
} from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';

import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';
import * as RepeatUtils from '../../../lib/repeatUtils';

import Console from '../../../lib/debug';

const MAX_REPEAT_TIMES = 10;
const DEFAULT_PROGRAM_LENGTH = 35;

class RepeatModal extends Component {
    state = {
        numWeeks: 1,
        days: [
            { fixedName: 'Day 1', name: 'Sunday', checked: false },
            { fixedName: 'Day 2', name: 'Monday', checked: false },
            { fixedName: 'Day 3', name: 'Tuesday', checked: false },
            { fixedName: 'Day 4', name: 'Wednesday', checked: false },
            { fixedName: 'Day 5', name: 'Thursday', checked: false },
            { fixedName: 'Day 6', name: 'Friday', checked: false },
            { fixedName: 'Day 7', name: 'Saturday', checked: false }
        ]
    };

    componentWillReceiveProps(nextProps) {
        let firstSession = _.first(_.values(nextProps.sessions));
        let isProgram = ProgramTypes.isProgram(nextProps.programType);
        let firstDay = isProgram
            ? firstSession.data.index
            : moment(firstSession.data.date).day();

        let days = this.state.days;
        for (let i = 0; i < days.length; i++) {
            days[i].checked = firstDay === i;
        }
        this.setState(days);
    }

    handleClose() {
        ClipboardState.cancelRepeatModal();
        ClipboardState.clearSelected();
    }

    handleDayChange(event) {
        let dayName = event.target.value;
        let days = this.state.days;
        for (let i = 0; i < days.length; i++) {
            if (days[i].name === dayName) days[i].checked = !days[i].checked;
        }
        this.setState(days);
    }

    handleNumWeeksChange(event) {
        let numWeeks = event.target.value;
        this.setState({ numWeeks });
    }

    handleSave() {
        let days = this.state.days;
        let dayIndexes = [];
        for (let i = 0; i < days.length; i++) {
            if (days[i].checked) dayIndexes.push(i);
        }
        RepeatUtils.repeat(
            this.props.sessions,
            this.state.numWeeks,
            this.isSingle(),
            dayIndexes,
            this.isProgram()
        );
        this.handleClose();
    }

    dialogHeaderText() {
        let sessionCount = this.sessionCount();
        return (
            'Repeat ' +
            sessionCount +
            ' Session' +
            (sessionCount > 1 ? 's' : '')
        );
    }

    sessionCount() {
        return _.keys(this.props.sessions).length;
    }

    isSingle() {
        return this.sessionCount() === 1;
    }

    dialogForm() {
        return this.isSingle()
            ? this.individualDialogForm()
            : this.multipleDialogForm();
    }

    availableRepeatTimes() {
        if (!this.isProgram()) return MAX_REPEAT_TIMES;

        return Math.ceil(this.props.programLength / 7) - 1;
    }

    multipleDialogForm() {
        let options = [];
        let availableRepeatTimes = this.availableRepeatTimes();

        for (let i = 1; i <= availableRepeatTimes; i++) {
            options.push(
                <MenuItem key={i} value={i}>
                    {i + ' Time' + (i > 1 ? 's' : '')}
                </MenuItem>
            );
        }

        return (
            <FormControl>
                <InputLabel htmlFor="num-weeks-select">Repeat</InputLabel>
                <Select
                    value={this.state.numWeeks}
                    onChange={this.handleNumWeeksChange.bind(this)}
                    inputProps={{ name: 'num-weeks', id: 'num-weeks-select' }}
                >
                    {options}
                </Select>
            </FormControl>
        );
    }

    firstSession() {
        return _.first(_.values(this.props.sessions));
    }

    individualOptions() {
        let firstSession = this.firstSession();
        let options = [];

        if (this.isProgram()) {
            let programLengthInWeeks = Math.ceil(this.props.programLength / 7);
            let firstSessionWeekIndex = firstSession.data.weekIndex;
            if (!firstSessionWeekIndex)
                firstSessionWeekIndex =
                    Math.ceil(firstSession.data.timeline_day / 7) - 1;
            let repeatOffset = programLengthInWeeks - firstSessionWeekIndex;

            for (let i = 0; i < repeatOffset; i++) {
                options.push(
                    <MenuItem key={i} value={i}>{`End of Week ${i +
                        firstSessionWeekIndex +
                        1}`}</MenuItem>
                );
            }
            return options;
        }

        let date = moment(firstSession.data.date, 'YYYY-MM-DD')
            .add(1, 'days')
            .endOf('isoWeek')
            .subtract(1, 'days');
        for (let i = 0; i < MAX_REPEAT_TIMES; i++) {
            options.push(
                <MenuItem key={i} value={i}>
                    {date.format('YYYY-MM-DD')}
                </MenuItem>
            );
            date.add(1, 'weeks');
        }

        return options;
    }

    individualDialogForm() {
        let options = this.individualOptions();

        return (
            <FormControl>
                <InputLabel htmlFor="num-weeks-select">
                    Repeat through
                </InputLabel>
                <Select
                    value={this.state.numWeeks}
                    onChange={this.handleNumWeeksChange.bind(this)}
                    inputProps={{ name: 'num-weeks', id: 'num-weeks-select' }}
                >
                    {options}
                </Select>
                {this.daySelect()}
            </FormControl>
        );
    }

    isProgram() {
        return ProgramTypes.isProgram(this.props.programType);
    }

    daySelect() {
        let isProgram = this.isProgram();
        return (
            <div>
                <Divider />
                <FormControl>
                    <br />
                    <FormLabel>Days</FormLabel>
                    <FormGroup>
                        {this.state.days.map(day => {
                            return (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={day.checked}
                                            onChange={this.handleDayChange.bind(
                                                this
                                            )}
                                            value={day.name}
                                        />
                                    }
                                    label={isProgram ? day.fixedName : day.name}
                                    key={day.fixedName}
                                />
                            );
                        })}
                    </FormGroup>
                </FormControl>
            </div>
        );
    }

    render() {
        Console.render('repeatModal');
        return (
            <Dialog
                open={this.props.enabled}
                onClose={this.handleClose}
                aria-labelledby="repeat-form"
            >
                <DialogTitle>{this.dialogHeaderText()}</DialogTitle>
                <DialogContent>{this.dialogForm()}</DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={this.handleSave.bind(this)}
                        color="primary"
                    >
                        Apply Changes
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        enabled: state.clipboard.repeatModalEnabled,
        sessions: state.clipboard.selectedSessions,
        programLength:
            state.calendar.infoTree.team.length || DEFAULT_PROGRAM_LENGTH,
        programType: state.calendar.infoTree.programType
    };
};

export default connect(mapStateToProps)(RepeatModal);
